import { makeStyles } from '@material-ui/core/styles'
import { Box, Card, FormControl } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { LIFE_COVER_VALUES } from 'src/utils/constants/BuyPolicyLife'
import { generateAgeList } from 'src/utils/commonMethods/buyPolicy'
import { useDispatch, useSelector } from 'react-redux'
import { updateLifeSelectedQuickQuote } from 'src/actions'
import { useState } from 'react'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const LifeQuoteFilter = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const selectedQuoteDetails = useSelector(
    (state) => state?.buyPolicyLifeReducer
  )

  const [selectValues, setSelectValues] = useState({
    lifeCover: selectedQuoteDetails?.lifeCover || '',
    coverTillAge: selectedQuoteDetails?.coverTillAge || '',
    modeofPremium: selectedQuoteDetails?.modeofPremium || '',
  })

  const handleChange = (event) => {
    const updatedDetails = {
      ...selectedQuoteDetails,
      [event?.target?.name]: event?.target?.value,
    }

    dispatch(updateLifeSelectedQuickQuote(updatedDetails))
    setSelectValues((prevValues) => ({
      ...prevValues,
      [event?.target?.name]: event?.target?.value,
    }))
  }

  return (
    <>
      <Card className={classes.filterCard}>
        <Box className={classes.insuranceProvider}>
          <span className={classes.selectText}>
            Customize Your Coverage Details
          </span>
        </Box>
        <Box className={classes.selectContainer}>
          <FormControl variant='outlined'>
            <InputLabel>Life Cover</InputLabel>
            <Select
              id='lifeCover'
              label='Life Cover'
              name='lifeCover'
              value={selectValues?.lifeCover || ''}
              onChange={(event) => handleChange(event)}
              displayEmpty
              onOpen={removeScroll}
              onClose={addScroll}
              fullWidth
              defaultValue=''
            >
              {LIFE_COVER_VALUES?.map((item, index) => (
                <MenuItem key={`${item?.label}${index}`} value={item?.value}>
                  {item?.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant='outlined'>
            <InputLabel>Cover Till Age</InputLabel>
            <Select
              id='coverTillAge'
              label='Cover Till Age'
              name='coverTillAge'
              value={selectValues?.coverTillAge || ''}
              onChange={handleChange}
              displayEmpty
              fullWidth
              onOpen={removeScroll}
              onClose={addScroll}
              defaultValue=''
            >
              {generateAgeList(30, 85)?.map((item, index) => (
                <MenuItem key={`${item}${index}`} value={item}>
                  {item + ' Years'}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant='outlined'>
            <InputLabel>Mode of Premium Payment</InputLabel>
            <Select
              id='modeofPremium'
              label='Mode of Premium Payment'
              name='modeofPremium'
              value={selectValues?.modeofPremium || ''}
              onChange={handleChange}
              displayEmpty
              fullWidth
              onOpen={removeScroll}
              onClose={addScroll}
              defaultValue=''
            >
              <MenuItem value={'YEARLY'}>Yearly</MenuItem>
              <MenuItem value={'HALF_YEARLY'}>Half Yearly</MenuItem>
              <MenuItem value={'QUARTERLY'}>Quarterly</MenuItem>
              <MenuItem value={'MONTHLY'}>Monthly</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Card>
    </>
  )
}

export default LifeQuoteFilter

const useStyles = makeStyles({
  coveragesContent: {
    display: 'flex',
    flexDirection: 'Column',
    justifyContent: 'center',
    padding: '40px 30px 0px 40px',
  },
  filterCard: {
    border: '6px',
    borderRadius: '10px !important',
    boxShadow: '0px 4px 7px 0px #0000001A',
    marginTop: '6px',
    background: 'linear-gradient( #02A9F9 -800%, #FFFFFF 100%)',
    padding: '30px 20px',
  },
  dividerContent: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#E45C91',
  },
  chooseContent: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#707070',
    marginBottom: '-5px',
  },
  label: {
    fontSize: '14px !important',
    fontWeight: '500',
  },
  motorContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    boxSizing: 'border-box',
    background: '#E9E9E9',
    padding: '10px 10px',
    borderRadius: '8px',
  },
  insuranceProvider: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingTop: '15px',
    width: '100%',
  },

  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 40px 20px 40px',
  },
  selectText: {
    fontSize: '16px',
    color: '#2BA6C8',
    fontWeight: '500',
  },
})
